function arrayBufferToHex(buffer) {
    return Array.from(buffer)
        .map(b => b.toString(16).padStart(2, "0"))
        .join("");
}

export async function encryptAES(text, secretKey) {
    const encoder = new TextEncoder();

    // Convert secret key to a Uint8Array
    const key = await crypto.subtle.importKey(
        "raw",
        encoder.encode(secretKey),
        { name: "AES-GCM", length: 256 },
        false,
        ["encrypt"]
    );

    // Generate a random IV (Initialization Vector)
    const iv = crypto.getRandomValues(new Uint8Array(12));

    // Encrypt the text
    const encrypted = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv },
        key,
        encoder.encode(text)
    );

    // Convert encrypted data and IV to HEX
    const ivHex = arrayBufferToHex(iv);
    const encryptedHex = arrayBufferToHex(new Uint8Array(encrypted));

    return { iv: ivHex, encrypted: encryptedHex };
}
